module.exports = __webpack_public_path__ + "static/img/shop-brand-bg.bb24b327.png";